<!-- components/ReviewStatusTag.vue -->
<template>
  <el-tag :type="tagType" :size="size" effect="plain">
    {{ statusText }}
  </el-tag>
</template>

<script>
export default {
  name: 'ReviewStatusTag',
  props: {
    status: {
      type: String,
      required: true,
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  computed: {
    tagType() {
      const typeMap = {
        ALL_AVAILABLE: 'success',
        PART_AVAILABLE: 'warning',
        UNAVAILABLE: 'danger',
        AUDIT: 'info'
      }
      return typeMap[this.status] || 'info'
    },
    statusText() {
      const textMap = {
        ALL_AVAILABLE: '审核通过',
        PART_AVAILABLE: '部分通过',
        UNAVAILABLE: '审核拒绝',
        AUDIT: '审核中'
      }
      return textMap[this.status] || this.status || '未知'
    }
  }
}
</script>